var ImageViewer = require('./ImageViewer');

module.exports = ImageViewer;
